<template>
  <div class="Contents">
    <v-container>
      <v-row class="text-center">
        <v-col class="mb-4">
          <h1 class="display-2 font-weight-bold mb-3">
            2021年9月28日（火）尾張繊維技術センター様
          </h1>
          <h2 class="display-1 font-weight-bold mb-3">
            Jetson nanoで粉体物性を予測する
          </h2>
        </v-col>
      </v-row>

      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">時間</th>
              <th class="text-left">項目</th>
              <th class="text-left">内容</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in timetable"
              :key="i"
              v-on:click="goto(item.section)"
            >
              <td>{{ item.time }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.detail }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-banner outlined sticky class="light-green text-center py-5">
        学習用コンテンツ
      </v-banner>
      <v-card class="mx-auto" outlined>
        <markdown-it-vue class="md-body" :content="markdown" />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import MarkdownItVue from "markdown-it-vue";
import "markdown-it-vue/dist/markdown-it-vue.css";

export default {
  name: "Contents",
  components: {
    MarkdownItVue,
  },
  methods: {
    goto: function (section) {
      import(`raw-loader!./1-${section}.md`).then((res) => {
        console.log(res);
        this.markdown = res.default;
      });
    },
  },
  data: () => ({
    id: 1,
    section: 1,
    markdown: `
# さあ始めましょう

## 目次をクリックするとテキストが表示されます`,
    timetable: [
      {
        section: 1,
        time: "9:30〜9:45",
        name: "イントロダクション",
        detail: "講師紹介、本日の内容説明など",
      },
      {
        section: 2,
        time: "9:45〜10:15",
        name: "Jetson nano組み立て〜ツール導入",
        detail: "事前準備済みの機器組み立てとツール導入について説明",
      },
      {
        section: 3,
        time: "10:15〜12:00",
        name: "既存の学習済モデルを使った静止画の推論",
        detail:
          "事前準備済みのツール導入を使った推論の実習、および処理内容の解説",
      },
      {
        section: 4,
        time: "12:00〜13:00",
        name: "昼休憩",
        detail: "VDT作業の後なのでゆっくり目を休めてください",
      },
      {
        section: 5,
        time: "13:00〜14:00",
        name: "学習済モデル作成の基礎",
        detail: "学習済モデル作成の基礎、およびツールの使い方など",
      },
      {
        section: 6,
        time: "14:00〜16:15",
        name: "学習済モデル作成実習",
        detail:
          "予め準備した教師画像を用いて自分だけのモデルを作成し、推論性能をまとめる",
      },
      {
        section: 7,
        time: "およそ15:00ごろ",
        name: "小休憩(1)",
        detail: "各自で進捗に合わせて小休憩を取ってください",
      },
      {
        section: 8,
        time: "16:15〜16:30",
        name: "小休憩(2)",
        detail: "進捗調整を兼ねます",
      },
      {
        section: 9,
        time: "16:30〜17:00",
        name: "本日の復習",
        detail:
          "推論性能について考察し、機械学習の良し悪しについて学ぶ",
      },
      {
        section: 10,
        time: "17:00〜17:30",
        name: "質疑応答、まとめ",
        detail: "進んだ学習の進め方、アンケート、フィードバックなど",
      },
    ],
  }),
};
</script>

<style>
@media screen and (max-width: 480px) {
  .signin div {
    min-width: 0;
  }
}
</style>